import { schema } from "normalizr";
import { CollectionPermission as CollectionPermissionRecord } from "records/collection";
import { List } from "immutable";

const processStrategyNewValue = (permissions) => {
    const newPermissions = (permissions.permissions || permissions).map((permission) => {
        permission.collectionId = permission.collection_id;
        return permission;
    });

    return {
        collectionId: newPermissions[0].collection_id,
        users: List(newPermissions),
    };
};

export const CollectionPermission = new schema.Entity(
    "collectionPermissions",
    {},
    {
        idAttribute: (permissions) => {
            if (permissions.length) {
                return permissions[0].collection_id;
            } else if (permissions.permissions && permissions.permissions.length) {
                // for /assortment permissions
                return permissions.permissions[0].collection_id;
            } else {
                return permissions.collection_id;
            }
        },
        processStrategy: (permissions) => {
            if (permissions.length || (permissions.permissions && permissions.permissions.length)) {
                return processStrategyNewValue(permissions);
            } else {
                return permissions;
            }
        },
    }
);

(CollectionPermission as any).record = CollectionPermissionRecord;
